import { createSlice } from '@reduxjs/toolkit'

/**
 * Redux slice, que maneja las acciones que modifican
 * el estado de la interfaz de la aplicación.
 */
const uiSlice = createSlice({
  name: 'ui',
  initialState: {
    cargando: false,
    tipo: '',
    titulo: '',
    mensaje: '',
    dialogoAbierto: false,
    callback: null
  },
  reducers: {
    /**
     * Acción que inicia el estado de carga del slice.
     * @param {Object} state - Estado actual del uiSlice.
     */
    startLoading: (state) => {
      state.cargando = true
    },
    /**
     * Acción que finaliza el estado de carga del slice.
     * @param {Object} state - Estado actual del uiSlice.
     */
    finishLoading: (state) => {
      state.cargando = false
    },
    /**
     * Acción que establece el estado de un diálogo y sus propiedades.
     * @param {Object} state - Estado actual del slice.
     * @param {String} payload - Payload que contiene los valores del diálogo.
     * @param {boolean} payload.abierto - Valor que indica si el estado de apertura del dialogo.
     * @param {Function} payload.callback - Callback a ejecutar cuando se confirma el diálogo.
     * @param {string} [payload.mensaje=""] - Mensaje que se mostrará en el diálogo.
     * @param {string} [payload.tipo="info"] - Tipo de diálogo a mostrar.
     * @param {string} payload.titulo - Título que se mostrará en el diálogo.
     */
    setDialogoAbierto: (state, { payload }) => {
      const { abierto, callback, mensaje = '', tipo = 'info', titulo } = payload
      state.dialogoAbierto = abierto
      state.callback = callback
      state.mensaje = mensaje
      state.tipo = tipo
      state.titulo = titulo
    }
  }
})

export const { startLoading, finishLoading, setDialogoAbierto } = uiSlice.actions
export default uiSlice.reducer
